export default "data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAABwAgCdASogACAALiUYjEYREREBABIlpAADyVYAAP782eX/J6F/rUb/8mVAAA=="